module.exports = __webpack_public_path__ + "static/media/what-can-prevent.3da591e0.png";